/** @format */

// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'production') __webpack_nonce__ = window.NONCE_ID;
